var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiIconApi101Focus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "192px",
    viewBox: "0 0 241 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API101_focus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API101_focus",
    transform: "translate(0.500000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_Over",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#A48923",
    strokeWidth: 12,
    fill: "#A48923",
    x: 6,
    y: 6,
    width: 228,
    height: 180,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1A4480",
    x: 15,
    y: 16,
    width: 210,
    height: 160
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.2839307,112.522184 L119.618864,132.162995 L174.953796,112.522184 C187.315013,125.808194 194.865425,143.556561 194.865425,163.052466 C194.865425,164.299876 194.834515,165.540132 194.773412,166.772523 C192.817288,154.013165 159.917592,143.860731 119.618864,143.860731 C79.3201351,143.860731 46.4204394,154.013165 44.4643152,166.772523 C44.4032123,165.540132 44.3723021,164.299876 44.3723021,163.052466 C44.3723021,143.556561 51.9227144,125.808194 64.2839308,112.522184 Z",
    id: "Combined-Shape",
    fill: "#7995BA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#7995BA",
    points: "119.618864 40 239.237727 82.4580166 119.618864 124.916033 1.30487416e-13 82.4580166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.055311,82.4580166 C69.6851036,95.4860055 44,102 44,102 C44,102 44,129.833333 44,185.5",
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 44.0642431,
    cy: 119.652332,
    rx: 5.19194106,
    ry: 7.35620441
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0642431,190.271894 C46.931673,190.271894 49.2561842,186.978409 49.2561842,182.91569 C49.2561842,178.85297 46.931673,123.543433 44.0642431,123.543433 C41.1968133,123.543433 38.8723021,178.85297 38.8723021,182.91569 C38.8723021,186.978409 41.1968133,190.271894 44.0642431,190.271894 Z",
    id: "Oval-Copy",
    fill: "#FFFFFF"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiIconApi101Focus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/API_icon_API101_focus.eb36ed2b8fa6850f19ba78a3e032c447.svg";